<template>
  <div>
    <el-form ref="activityForm" class="UniformCss" :inline="true" :model="activity" :rules="rules" label-width="130px">
      <div class="activityFormLine">活动计划信息</div>
      <div class="budgetBox">
        <el-row>
          <el-col :span="8">
            <el-form-item label="市场活动来源" prop="selectedOrgText">
              <el-select ref="selectOrgPopup" v-model="selectedOrgText" class="sourceSelect" placeholder="选择活动来源" readonly @click.native="showTree" />
            </el-form-item>
          </el-col>
        <!-- </el-row> -->
        <!-- <el-row>
          <el-col :span="8">
            <el-form-item label="一级来源">
              <el-input v-model="activity.oneLevelName" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="二级来源">
              <el-input v-model="activity.twoLevelName" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="三级来源">
              <el-input v-model="activity.threeLevelName" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- <el-row> -->
          <!-- <el-col :span="8">
            <el-form-item label="四级来源">
              <el-input v-model="activity.fourLevelName" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="五级来源">
              <el-input v-model="activity.fiveLevelName" :disabled="true" />
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="8">
            <el-form-item label="归属分类">
              <el-input v-model="classType.belongClass" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="来源分类">
              <el-input v-model="classType.sourceClass" :disabled="true" />
            </el-form-item>
          </el-col> -->

          <!-- <el-col :span="8">
            <el-form-item label="归属分类">
              <el-input v-model="activity.belongClass" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="来源分类">
              <el-input v-model="activity.sourceClass" :disabled="true" />
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="活动名称" prop="actName">
              <el-input v-model="activity.actName" :disabled="Boolean(activity.actplanid)" placeholder="请填写活动名称" />
            </el-form-item>
          </el-col>
        <!-- </el-row>
        <el-row> -->
          <!-- <el-col :span="8">
            <el-form-item label="预算类型" prop="budgetTypeCode">
              <el-select ref="budgetSelect" v-model="activity.budgetTypeCode" :disabled="Boolean(activity.actplanid)" placeholder="请选择预算类型" @change="changeBudgetType">
                <el-option v-for="item in budtypeList" :key="item.valueCode" :label="item.valueName" :value="item.valueCode" />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="政策立项编号" prop="projectCode">
              <el-input v-model="activity.projectCode" placeholder="请填写政策立项编号" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="计划编码">
              <el-input v-model="activity.planCode" :disabled="true" />
            </el-form-item>
          </el-col> -->
        <!-- </el-row>
        <el-row> -->
            <el-col :span="8">
              <el-form-item label="生效时间" prop="planStartTime">
                <el-date-picker
                  style="width: 172px;"
                  v-model="activity.planStartTime"
                  type="date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"
                  @change="activity.planEndTime = ''"
                />
                <!-- @change="beginChange" -->
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="失效时间" prop="planEndTime">
                <el-date-picker
                  style="width: 172px;"
                  v-model="activity.planEndTime"
                  type="date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="{ disabledDate: time => time.getTime()-8.64e7 < new Date(activity.planStartTime) }"
                  placeholder="选择日期"
                />
                <!-- @change="endChange" -->
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="类型">
                <el-input :value="activity.type == 0 ? '大区' : '总部'" :disabled="true" />
              </el-form-item>
            </el-col> -->
        </el-row>
        <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="状态">
                <el-input :value="activity.planStatus == 0 ? '待发布' : '已发布'" :disabled="true" />
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col>
              <el-form-item label="执行车系" prop="carSeries" label-width="116px">
                <el-tooltip class="item" effect="dark" :content="activity.strainsCarName" placement="top-start">
                  <el-select
                    style="width: 470px;"
                    ref="selectCarSeriesPopup"
                    v-model="activity.strainsCarName"
                    placeholder="请选择执行车系"
                    class="proxySelect"
                    :visible-change="false"
                    @click.native="onShowCarSeries"
                  />
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row> -->
         <el-row>
          <el-col :span="18" style="height: auto">
            <el-form-item label="其他说明" prop="remarks" label-width="116px">
              <el-input
                v-model="activity.remarks"
                type="textarea"
                :disabled="Boolean(activity.actplanid)"
                style="width: 470px;"
                maxlength="400"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 10 }"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-dialog title="选择三级来源" :visible.sync="showDialog1" center width="40%">
      <FiveSourceTree v-if="showDialog1" ref="sourceTree" :tree-data="treeData" :check-key="checkKey" />
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="handleDialogCancel">取 消</vxe-button>
        <vxe-button status="primary" @click="handleDialogConfirm">确 定</vxe-button>
      </span>
    </el-dialog>
    <el-dialog title="选择车系" :visible.sync="showCarSeries" width="40%">
      <vxe-table
        ref="xTable"
        v-loading="carLoad"
        border
        class="mytable-scrollbar"
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        style="margin-top: 10px"
        :max-height="$store.state.app.height - 350 < 185 ? 185 : $store.state.app.height - 350"
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :checkbox-config="{checkRowKeys: defaultSelecteRows}"
        :data="SelectLists.subSeries"
      >
        <vxe-column type="checkbox" width="60" align="center" />
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <vxe-column title="品系" align="center">
          <template #default="{ row }">
            <span>{{ row.value.split('-')[0] }}</span>
          </template>
        </vxe-column>
        <vxe-column title="车系" align="center">
          <template #default="{ row }">
            <span>{{ row.value.split('-')[1] }}</span>
          </template>
        </vxe-column>
      </vxe-table>
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="showCarSeries = false">取 消</vxe-button>
        <vxe-button status="primary" @click="onSeriesConfirm">确 定</vxe-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import { getOrganizationList, queryValueTypeByCode, queryCarSeriesInfo } from '@/api/activity.js'
import { getClassByCode } from '@/api/actPlan'
import FiveSourceTree from './FiveSourceTree/index.vue'
// import moment from 'moment';

export default {
  components: {
    FiveSourceTree
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['activity', 'classType'],
  data() {
    return {
      showDialog1: false, // 五级来源弹出框
      // 五级来源树状数据
      treeSourceList: [
        {
          sourceCode: 'default',
          parentNodeId: 'A',
          sourceName: '活动来源',
          enableSelect: '0',
          children: []
        }
      ],
      budtypeList: [],
      budgetTypeName: null,
      rules: {
        actName: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        budgetTypeCode: [{ required: true, message: '请选择预算类型', trigger: 'select' }],
        planStartTime: [{ required: true, message: '请选择生效时间', trigger: 'blur' }],
        planEndTime: [{ required: true, message: '请选择失效时间', trigger: 'blur' }],
        projectCode: [{ required: true, message: '请输入政策立项编号', trigger: 'blur' }],
        selectedOrgText: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.selectedOrgText) {
                callback(new Error('请选择活动来源'))
                return
              }
              callback()
            },
            trigger: 'blur'
          }
        ]
      },
      carLoad: false,
      checkBoxList: [], // 品系checkbox数组
      showCarSeries: false,
      carStrainList: [], // 车系列表
      checkedCarStrainList: [], // 已选车系
      defaultSelecteRows: [], // 默认选中行
      SelectLists: {},
      sourceData: [
        {
          sourceCode: 'default',
          parentNodeId: 'A',
          sourceName: '活动来源',
          enableSelect: '0',
          children: []
        }
      ],
      treeData: []
    }
  },
  computed: {
    selectedOrgText() {
      // if (this.activity.fiveLevelCode) {
      //   return this.activity.oneLevelName + '/' +
      //                        this.activity.twoLevelName + '/' +
      //                        this.activity.threeLevelName + '/' +
      //                        this.activity.fourLevelName + '/' +
      //                        this.activity.fiveLevelName
      // } else {
      //   return ''
      // }

      if (this.activity.threeLevelCode) {
        return this.activity.oneLevelName + '/' +
                             this.activity.twoLevelName + '/' +
                             this.activity.threeLevelName
      } else {
        return ''
      }
    },
    checkKey() {
      // return this.activity.fiveLevelCode
      return this.activity.threeLevelCode
      
    }
  },
  watch: {
  },
  created() {
    this.SelectListsFun()
    this.getBudgettype()
    this.getFiveLevelSource()
    // this.queryByPageCar()
  },
  mounted() {},
  methods: {
    SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['subSeries']).then(v => {
        this.SelectLists = v
      })
    },
    // 获取五级来源
    getFiveLevelSource() {
      getOrganizationList().then(res => {
        if (res.code === 1) {
          this.treeSourceList[0].children = res.data
          this.sourceData[0].children = res.data
          this.treeData = this.formatData(this.sourceData)
        console.log(this.treeData,'-------res-----')
        }
      })
    },
    // 树形数据初始化，外层节点添加disabled
    formatData(params) {
      const data = params
      data.forEach((item) => {
        if (item.children.length !== 0) {
          item.disabled = true
          this.formatData(item.children)
        }
      })
      return data
    },
    // 获取全部车系
    queryByPageCar() {
      // this.modelTable.loading = true
      var data = {
        page: 1,
        limit: 9999
      }
      queryCarSeriesInfo(data)
        .then(res => {
          if (res.code === 1 && res.data) {
            this.carStrainList = res.data.list
            this.getCheckboxList(this.carStrainList)
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(e => {
          this.$message.error(e)
        })
    },
    // 获取checkbox
    getCheckboxList(data) {
      this.checkBoxList = data.reduce((acc, obj) => {
        if (!acc.find(item => item.strainsCode === obj.strainsCode)) {
          acc.push(obj)
        }
        return acc
      }, [])
    },
    showTree() {
      this.showDialog1 = true
      this.$refs.selectOrgPopup.blur()
    },
    // 点击预算类型
    changeBudgetType(value) {
      const name = this.budtypeList.find(item => item.valueCode == value).valueName
      this.activity.budgetTypeName = name
    },
    // 获取预算类型
    getBudgettype() {
      queryValueTypeByCode({ typeCode: 'budgetary', page: 1, limit: 999 }).then(res => {
        if (res.code === 1) {
          this.budtypeList = res.data.list
        }
      })
    },
    // 取消
    handleDialogCancel() {
      this.showDialog1 = false
      // this.$refs.sourceTree.$refs.tree.setCheckedKeys([this.activity.fiveLevelCode])
      this.$refs.sourceTree.$refs.tree.setCheckedKeys([this.activity.threeLevelCode])
    },
    // 确认
    handleDialogConfirm() {
      this.selectData = this.$refs.sourceTree.selectData
      Object.assign(this.activity, this.selectData)
      // this.findClassByCode(this.activity.fiveLevelCode)
      this.findClassByCode(this.activity.threeLevelCode)
      this.showDialog1 = false
    },
    findClassByCode(code) {
      getClassByCode(code).then(res => {
        if (res.code === 1 && res.data) {
          this.$emit('update:classType', res.data)
        } 
        // else {
        //   this.$message.error(res.message)
        // }
      })
    },
    onShowCarSeries() {
      this.$refs.selectCarSeriesPopup.blur()
      this.showCarSeries = true
      this.$nextTick(() => {
        this.$refs.xTable.clearCheckboxRow()
        const stringArray = this.activity.strainsCarCode.split(',')
        const result = this.SelectLists.subSeries.filter(item => stringArray.some(value => item.code === value))
        this.$refs.xTable.setCheckboxRow(result, true)
      })
    },
    handleCheckedChange(value) {
      this.$refs.xTable.clearCheckboxRow()
      const result = this.carStrainList.filter(obj => value.includes(obj.strainsCode))
      this.$refs.xTable.setCheckboxRow(result, true)
    },
    onSeriesConfirm() {
      this.checkedCarStrainList = this.$refs.xTable.getCheckboxRecords()
      const codeArr = this.checkedCarStrainList.map(item => item.code)
      const nameArr = this.checkedCarStrainList.map(item => item.value)
      this.activity.strainsCarCode = codeArr.join(',')
      this.activity.strainsCarName = nameArr.join(',')
      this.showCarSeries = false
    }
  }
}
</script>
<style lang="less" scoped>
.activityFormLine {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.el-dialog-div {
  max-height: 50vh;
  overflow-x: hidden;
}
.sourceSelect .el-input .el-select__caret.el-input__icon::before {
  content: '';
}
.proxySelect {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .el-input .el-select__caret.el-input__icon::before {
    content: '';
  }
}
/deep/ .el-input__inner {
  height: 31px !important;
}
/deep/ .el-form-item {
  display: flex;
}
</style>
